import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ServicePartFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import ServicePartFormStepOne from "./ServicePartFormSteps/ServicePartFormStepOne";

const ServicePartForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);
  const [selectedParts, setSelectedParts] = useState(_initialValues?.parts || []);

  useEffect(() => {
    if (!update) {
      setInitialValues({
        ..._initialValues
      });
      return;
    }
    if (update) {
      setInitialValues({
        ..._initialValues,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit({ ...val, selectedParts }, props)}
      validate={(val) => onValidate({ ...val, selectedParts }, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ServicePartForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ServicePartFormStepOne {...formProps} {...props} setSelectedParts={setSelectedParts} selectedParts={selectedParts} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ServicePartForm;
